import shopifyGenericDefaults from '../shopify-generic/config.js';

shopifyGenericDefaults.Widgets.find((w) => w.name === 'FacetBarWheels').minFacetCount = 2;
shopifyGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').minFacetCount = 2;

const AutoSyncKey = 'signature-perfor';

function InitFunc() {
  if (window.document.querySelector('#cm_results, #cm-brand-list, #cm_manufacturers')) {
    const unwantedPageWrappers = [
      ['.page-container .rte', 'rte'],
      ['.container .rte', 'rte'],
      ['#MainContent .page-width.page-width--narrow', 'page-width--narrow'],
      ['#MainContent .container.container-narrow', 'container-narrow'],
      ['#MainContent .page-width .rte', 'rte'],
    ];

    unwantedPageWrappers.forEach(([elemSelector, className]) => {
      const wrapperElem = window.document.querySelector(elemSelector);
      wrapperElem?.classList.remove(className);
    });
  }
}

window.Convermax.toggleFitmentTable = () => {
  const fitmentTable = document.querySelector('.cm_fitment-table');
  fitmentTable.classList.toggle('cm_show-less');
  const showButton = document.querySelector('.cm_fitment-table-show-button');

  if (fitmentTable.classList.contains('cm_show-less')) {
    showButton.innerText = 'Show more';
  } else {
    showButton.innerText = 'Show less';
  }
};

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  InitFunc,
  pagination: {
    edgeRange: 0,
    centralRange: 2,
    disableDelimeters: true,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets,
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      initCollapsed: true,
      autoSyncVisualization: {
        apiKey: AutoSyncKey,
        config: {
          height: '120px',
        },
      },
    },
    {
      name: 'AutoSyncVisualizationDialog',
      apiKey: AutoSyncKey,
      template: 'fitmentSearch/autoSyncVisualizationDialog',
    },
  ],
};
